import React from "react";
import { useNavigate } from "react-router-dom";
import { FaChessBoard, FaClock, FaPrint, FaCheckDouble, FaChartLine } from "react-icons/fa";
import PageTitle from "../../components/PageTitle";

const Academic = () => {
  const navigate = useNavigate();
  const financeOptions = [
    {
      title: "Change Programme",
      description: "You can change your programme",
      icon: <FaChessBoard className="finance-icon" />,
      path: "/app/change-programme",
      color: "purple",
    },
    {
      title: "My Attendance",
      description: "My Semester Attendance",
      icon: <FaClock className="finance-icon" />,
      path: "/app/attendance",
      color: "blue",
    },
    {
      title: "Course Form",
      description: "My Registered Modules",
      icon: <FaPrint className="finance-icon" />,
      path: "/app/registered-modules",
      color: "green",
    },
  ];
  const academicOptions = [
    {
      title: "Progression",
      description: "My Academic Progression",
      icon: <FaChartLine className="finance-icon" />,
      path: "/app/progression",
      color: "yellow",
    },
    {
      title: "Academic Results",
      description: "My Academic Results",
      icon: <FaCheckDouble className="finance-icon" />,
      path: "/app/result",
      color: "orange",
    },
  ];
  return (
    <div>
      <PageTitle title="Academic Services" sub="Manage your academic services" />

      <div className="finance-grid">
        {financeOptions.map((option, index) => (
          <div key={index} className={`finance-card ${option.color} ${option.fullWidth ? "full-width" : ""}`} onClick={() => navigate(option.path)}>
            <div className="card-icon-container">{option.icon}</div>
            <div className="card-content">
              <h3>{option.title}</h3>
              <p>{option.description}</p>
            </div>
            <div className="card-arrow">→</div>
          </div>
        ))}
      </div>
      <div className="finance-grid my-5">
        {academicOptions.map((option, index) => (
          <div key={index} className={`finance-card ${option.color} ${option.fullWidth ? "full-width" : ""}`} onClick={() => navigate(option.path)}>
            <div className="card-icon-container">{option.icon}</div>
            <div className="card-content">
              <h3>{option.title}</h3>
              <p>{option.description}</p>
            </div>
            <div className="card-arrow">→</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Academic;
